<template>
  <label :class="`bundle bundle-${color}`">
    {{ $t(`voice.call.status.${value}`) }}
  </label>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        default: ''
      }
    },

    computed: {
      color: function() {
        /* eslint-disable no-unreachable, vue/script-indent */
        switch (this.value) {
          case 'sent': {
            return 'blue';
          }
          case 'pending': {
            return 'fresh';
          }
          case 'delivered': {
            return 'green';
          }
          case 'active': {
            return 'green';
          }
          case 'not_delivered': {
            return 'yellow';
          }
          case 'failed': {
            return 'error';
          }
          case 'error': {
            return 'error';
          }
          case 'rejected': {
            return 'orange';
          }
          case 'processing': {
            return 'orange';
          }
          default: {
            return 'default';
          }
        }
        /* eslint-enable */
      }
    }
  };
</script>
